import bezier from "../easings/easing-bezier";
import spring from "../easings/easing-spring";

/**
 * @type {DefaultOptionsFunctionProps}
 */
export const G_EasingFunctionDefaults = new Map([
  ["spring", spring(20, 5)],
  ["elastic", spring(20, 5)],
  ["linear", bezier(0, 0, 1, 1)],
  ["ease-in", bezier(0.5, 0, 1, 0.8)],
  ["ease-out", bezier(0, 0.25, 0.5, 1)],
  ["ease-in-out", bezier(0.5, 0, 0.2, 1)],
  ["ease-in-expo", bezier(0.7, 0, 0.84, 0)],
  ["ease-out-expo", bezier(0.16, 1, 0.3, 1)],
  ["ease-in-out-expo", bezier(0.85, 0, 0.15, 1)],
]);
